import { Outlet } from 'react-router-dom';
import { clsx } from 'clsx';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Toast } from '../common/Toast';
import { useSidebarStore } from '../../store';

export function Layout() {
  const { isExpanded } = useSidebarStore();

  return (
    <div className="h-screen overflow-hidden bg-[var(--color-bg-secondary)] bg-grid-pattern flex flex-col">
      <Sidebar />
      <Header />

      <main
        className={clsx(
          'pt-16 flex-1 overflow-auto transition-all duration-300 relative z-10',
          // On mobile, no margin (sidebar is overlay)
          'ml-0',
          // On desktop, add margin based on sidebar state
          isExpanded ? 'md:ml-52' : 'md:ml-20'
        )}
      >
        <div className="p-4 md:p-6 h-full">
          <Outlet />
        </div>
      </main>

      <Toast />
    </div>
  );
}
